import { createFileRoute } from "@tanstack/react-router";
import { KeywordServiceLanding } from "@/components/KeywordServiceLanding";
import { keywordServiceHead } from "@/lib/keywordServicePages";
import { getTownMarketingPage } from "@/lib/townMarketingPages";

const PAGE = getTownMarketingPage("castle-pines");

export const Route = createFileRoute("/marketing-castle-pines")({
  head: () => keywordServiceHead(PAGE),
  component: () => <KeywordServiceLanding page={PAGE} />,
});
